import { useIntl } from 'react-intl';

import { RootState } from '../../../../reducers';

import * as CustomerActions from '../../../../actions/customer';
import { CSVLink } from 'react-csv';
import { CircularProgress, Divider, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { CustomerRouteParams } from '../../../../pages/customer/models';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { WikusButton } from '@wikus-ui/components/core/button';
import { WikusItem } from '@wikus-ui/components/core/spacing';
import { WikusPanel } from '@wikus-ui/components/core/card';
import { kebabCase } from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import { unwrapCustomerState } from '../../../../utils/url';
import { useActions } from '../../../../actions';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

export const CustomerConsignmentWarehouseWithdrawals = () => {
  const intl = useIntl();
  const classes = useStyles();
  const { id: customerId } = useParams<CustomerRouteParams>();
  const customerUserActions: typeof CustomerActions = useActions(CustomerActions);
  const customerWithdrawals = useSelector((state: RootState) => unwrapCustomerState(state.customerWithdrawals));
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());

  useEffect(() => {
    if (customerId) {
      customerUserActions.fetchWithdrawals(customerId, selectedDate?.toISOString());
    }
  }, [customerId, selectedDate]);

  return (
    <>
      <WikusPanel
        title={intl.formatMessage({ id: 'customers.tabs.consignmentWarehouse.withdrawals' })}
        description={customerWithdrawals ? `${new Date(customerWithdrawals.start).toLocaleDateString()} - ${new Date(customerWithdrawals.end).toLocaleDateString()}` : undefined}
      >
        {!customerWithdrawals ? <CircularProgress style={{ width: '25px', height: '25px' }} color="inherit" /> : null}
        {customerWithdrawals ? <>
          <WikusItem spacingDirection='down'>
            <KeyboardDatePicker
              views={['year', 'month']}
              label="Monat wählen"
              value={selectedDate}
              onChange={setSelectedDate}
              format="MMMM yyyy"
              disableToolbar
              variant="inline"
            />
          </WikusItem>
          {customerWithdrawals.withdrawalsByStockArticle?.length ? <WikusItem spacingDirection="down">
            <CSVLink
              data={customerWithdrawals.withdrawalsByStockArticle}
              filename={`withdrawals-by-articles-${kebabCase(customerId)}-${kebabCase(selectedDate?.toLocaleDateString())}.csv`}>
              <WikusButton color='primary'>Download CSV</WikusButton>
            </CSVLink>
          </WikusItem> : null}
          <WikusItem spacingDirection="down">
            <TableContainer component={Paper}>
              <Table stickyHeader size="small" className={classes.table} aria-label="simple table">
                {customerWithdrawals.withdrawalsByStockArticle?.length === 0 ? <caption>No entries found!</caption> : null}
                <TableHead>
                  <TableRow>
                    <TableCell>Customer number</TableCell>
                    <TableCell align="right">Article number</TableCell>
                    <TableCell align="right">Amount (pcs/m)</TableCell>
                    <TableCell align="right">Date</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {customerWithdrawals.withdrawalsByStockArticle?.map((row) => (
                    <TableRow key={kebabCase(row.articleNumber + row.date)}>
                      <TableCell component="th" scope="row">
                        {row.customerNumber}
                      </TableCell>
                      <TableCell align="right">{row.articleNumber}</TableCell>
                      <TableCell align="right">{row.amount}</TableCell>
                      <TableCell align="right">{row.date}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </WikusItem>
        </> : null}
        <WikusItem spacingDirection="down">
          <Divider></Divider>
        </WikusItem>
        {customerWithdrawals?.withdrawals.length ? <WikusItem spacingDirection="down">
          <CSVLink
            data={customerWithdrawals.withdrawals}
            filename={`withdrawals-${kebabCase(customerId)}-${kebabCase(selectedDate?.toLocaleDateString())}.csv`}>
            <WikusButton color='primary'>Download CSV</WikusButton>
          </CSVLink>
        </WikusItem> : null}
        <WikusItem spacingDirection="down">
          <TableContainer component={Paper}>
            <Table stickyHeader size="small" className={classes.table} aria-label="simple table">
              {customerWithdrawals?.withdrawals?.length === 0 ? <caption>No entries found!</caption> : null}
              <TableHead>
                <TableRow>
                  <TableCell>Customer number</TableCell>
                  <TableCell align="right">Article number</TableCell>
                  <TableCell align="right">Amount (pcs/m)</TableCell>
                  <TableCell align="right">Date</TableCell>
                  <TableCell align="right">Coil ID</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {customerWithdrawals?.withdrawals.map((row) => (
                  <TableRow key={row.date}>
                    <TableCell component="th" scope="row">
                      {row.customerNumber}
                    </TableCell>
                    <TableCell align="right">{row.articleNumber}</TableCell>
                    <TableCell align="right">{row.amount}</TableCell>
                    <TableCell align="right">{new Date(row.date).toLocaleDateString()}</TableCell>
                    <TableCell align="right">{row.coilId}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </WikusItem>
      </WikusPanel>
    </>
  );
};
